<div class="d-flex flex-column w-100">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <!-- INFO Headline -->
      <div class="d-flex flex-column mt-5">
        <p class="fw-normal" style="font-size: 56px; line-height: normal;">Create an account</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <!-- INFO Sign up with Google Button -->
      <div class="d-flex w-100 mb-3 gap-2">
        <button mat-stroked-button class="w-100 px-3 py-4 rounded-3e border border-gray" color="primary" [disabled]="inProgress" (click)="signUpWithGoogle()">
          <div class="d-flex w-100">
            <!-- INFO Google Icon -->
            <app-google-icon class="w-24px h-24px"></app-google-icon>
            <span class="ms-2 my-auto mat-body-1 fw-bold text-black">Google</span>
          </div>
        </button>

        <button mat-stroked-button class="w-100 px-3 py-4 rounded-3e border border-gray" color="primary" [disabled]="inProgress" (click)="signUpWithApple()">
          <div class="d-flex w-100">
            <!-- INFO Apple Icon -->
            <app-apple-icon class="w-24px h-24px"></app-apple-icon>
            <span class="ms-2 my-auto mat-body-1 fw-bold text-black">Apple</span>
          </div>
        </button>
      </div>

      <form [formGroup]="form" class="d-flex flex-column w-100 mt-4">
        <span *ngIf="showError" class="mb-3 mat-caption text-danger">{{ errorText }}</span>

        <!-- INFO Email -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" type="text" placeholder="Your Name">
          <mat-icon matSuffix fontSet="material-symbols-outlined">abc</mat-icon>
        </mat-form-field>

        <!-- INFO Email -->
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Email">
          <mat-icon matSuffix fontSet="material-symbols-outlined">mail</mat-icon>
        </mat-form-field>

        <!-- INFO Password -->
        <!-- INFO https://stackoverflow.com/questions/50303454/how-to-use-the-new-material-design-icon-themes-outlined-rounded-two-tone-and -->
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput placeholder="Password" formControlName="password" [type]="hide ? 'password' : 'text'">
          <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                  [attr.aria-pressed]="hide">
            <mat-icon fontSet="material-symbols-outlined">{{hide ? 'visibility_off' :
              'visibility'}}</mat-icon>
          </button>

          <mat-hint class="line-height-normal">minimum 8 characters, you are advised to choose a strong password</mat-hint>
        </mat-form-field>

        <!-- INFO Terms and Conditions -->
        <p class="mt-3 p-2e mat-body">
          By signing up, I agree to AshGridX's <a href="https://docs.google.com/document/d/e/2PACX-1vQBd7q3L1vVHSlqOA35FEWjPXqAY4RuIv1KWcwghBj85YH9Qgzmf75bt_ti_Yc_-BhZvPUGo4VGXbJC/pub" class="text-primary">Terms of Service</a> and <a href="https://ashgridx.com/privacy-policy" class="text-primary">Privacy Policy</a>
        </p>

        <!-- INFO Submit Button -->
        <!-- px-3 py-2 -->
        <button mat-flat-button class="my-4 px-3 py-4 fw-bold rounded-3e" color="primary" [disabled]="inProgress || form.invalid" (click)="signUpWithEmailAndPassword()">
          <span class="my-auto mat-body-1 fw-bold">Create Account</span>
        </button>
      </form>

      <!-- INFO Already have an AshGridX account? Log in -->
      <p class="mx-auto mb-auto p-2e mat-body-1">
        Already have an AshGridX account?
        <a [routerLink]="getLoginRoute" [queryParams]="queryParams" [queryParamsHandling]="'preserve'" class="ms-1 text-primary">Log in</a>
      </p>
    </div>
  </div>
</div>
